<template>
    <div class="twitter-card">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'TwitterCard',
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';

    .twitter-card {
        overflow:         auto;
        flex-basis:       100%;

        border:           0.1rem solid $gray-200;
        padding:          2rem 3rem;

        background-color: $white;
    }
</style>
